var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLikedComment = function SvgLikedComment(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FF5E6D",
    clipRule: "evenodd",
    d: "M6.73134 12.4394C7.09751 12.7716 7.64447 12.768 8.00612 12.431C9.55669 10.986 13.4166 7.1542 13.4166 4.81782C13.4166 3.30152 12.4992 1.75 10.5025 1.75C8.88359 1.75 7.37257 3.74954 7.37257 3.74954C7.37257 3.74954 5.86156 1.75 4.24262 1.75C2.24592 1.75 1.16663 3.31314 1.16663 4.81782C1.16663 7.15875 5.14543 11.0009 6.73134 12.4394Z",
    stroke: "#FF5E6D",
    strokeWidth: 1.1
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLikedComment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/likedComment.c6239ce996b44f729c4df36576797769.svg";